import React from 'react';
import { Routes as RouterRoutes, Route } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute';
import ApplicationLayout from './components/ApplicationLayout';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import OrdersPage from './pages/OrdersPage';
import OrderDetailPage from './pages/OrderDetailPage';
import CodesPage from './pages/CodesPage';
import CodeDetailPage from './pages/CodeDetailPage';
import UsersPage from './pages/UsersPage';
import UserDetailPage from './pages/UserDetailPage';
import ChatsPage from './pages/ChatsPage';
import ChatDetailPage from './pages/ChatDetailPage';
import LedgerPage from './pages/LedgerPage';
import StatusPage from './pages/StatusPage';

function ProtectedLayout({ children }: { children: React.ReactNode }) {
	return (
		<ProtectedRoute>
			<ApplicationLayout>{children}</ApplicationLayout>
		</ProtectedRoute>
	);
}

const Routes: React.FC = () => {
	return (
		<RouterRoutes>
			<Route path="/login" element={<LoginPage />} />
			<Route
				path="/"
				element={
					<ProtectedLayout>
						<DashboardPage />
					</ProtectedLayout>
				}
			/>
			<Route
				path="/orders"
				element={
					<ProtectedLayout>
						<OrdersPage />
					</ProtectedLayout>
				}
			/>
			<Route
				path="/orders/:id"
				element={
					<ProtectedLayout>
						<OrderDetailPage />
					</ProtectedLayout>
				}
			/>
			<Route
				path="/codes"
				element={
					<ProtectedLayout>
						<CodesPage />
					</ProtectedLayout>
				}
			/>
			<Route
				path="/codes/:id"
				element={
					<ProtectedLayout>
						<CodeDetailPage />
					</ProtectedLayout>
				}
			/>
			<Route
				path="/ledger"
				element={
					<ProtectedLayout>
						<LedgerPage />
					</ProtectedLayout>
				}
			/>
			<Route
				path="/users"
				element={
					<ProtectedLayout>
						<UsersPage />
					</ProtectedLayout>
				}
			/>
			<Route
				path="/users/:id"
				element={
					<ProtectedLayout>
						<UserDetailPage />
					</ProtectedLayout>
				}
			/>
			<Route
				path="/chats"
				element={
					<ProtectedLayout>
						<ChatsPage />
					</ProtectedLayout>
				}
			/>
			<Route
				path="/chats/:userId"
				element={
					<ProtectedLayout>
						<ChatDetailPage />
					</ProtectedLayout>
				}
			/>
			<Route
				path="/status"
				element={
					<ProtectedLayout>
						<StatusPage />
					</ProtectedLayout>
				}
			/>
		</RouterRoutes>
	);
};

export default Routes;
